import type { QueryClient } from "@tanstack/react-query";
import type { AdminTicket } from "@sd/types/admin";
import type { TicketStatus } from "@sd/types/ticket";
import { toast } from "sonner";
import { patchTicketCreate } from "@sd/lib/patchTicketCreate";

/** PATCH `/service_desk/ticket_create/{id}/` with `status` (+ optional fields). */
export async function putTicketFormilyStatus(
  queryClient: QueryClient,
  ticketId: string,
  statusNext: AdminTicket["status"] | TicketStatus,
  extraFields?: Record<string, unknown>
): Promise<boolean> {
  try {
    const ok = await patchTicketCreate(queryClient, ticketId, {
      status: statusNext,
      ...extraFields,
    });
    if (!ok) {
      toast.error("Status could not be saved.");
      return false;
    }
    return true;
  } catch {
    toast.error("Status could not be saved.");
    return false;
  }
}
